<div class="flex-fill d-flex flex-column">
    <dx-form [formData]="filter" class="d-flex pt-3 ps-3" [colCount]="6">
        <dxi-item itemType="group" [colSpan]="2">
            <dxi-item dataField="startDate" editorType="dxDateBox"></dxi-item>
            <dxi-item dataField="endDate" editorType="dxDateBox"></dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="3">
            <dxi-item
                dataField="partId"
                editorType="dxSelectBox"
                [editorOptions]="{ dataSource: partNumbersDS, valueExpr: 'id', displayExpr: 'partNumber', width: '250px' }"
                [colSpan]="3"
            ></dxi-item>
            <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
        </dxi-item>

        <dxi-item>
            <div *dxTemplate class="d-flex flex-column" style="width: 80px">
                <button class="btn btn-success" (click)="search()">Search</button>
                <button class="btn btn-secondary mt-1" (click)="clear()">Clear</button>
            </div>
        </dxi-item>
    </dx-form>
    <div class="flex-fill d-flex flex-row">
        <div class="col-sm-6 p-3">
            <div class="grid-fill">
                <dx-data-grid
                    #orderLineDetailPartsGrid
                    keyExpr="id"
                    [dataSource]="orderLineDetailParts"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onSelectionChanged)="selectionChange($event)"
                >
                    <dxi-column dataField="id" width="65"></dxi-column>
                    <dxi-column dataField="orderLineDetailId" caption="Detail Id" width="65"></dxi-column>
                    <dxi-column dataField="partId" width="65"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Part #" width="100"></dxi-column>
                    <dxi-column dataField="description" width="200"></dxi-column>
                    <dxi-column dataField="quantity" width="70"></dxi-column>
                    <dxi-column dataField="status" width="110"></dxi-column>
                    <dxi-column dataField="built" dataType="date" format="shortDate" width="80"></dxi-column>
                    <dxi-column dataField="created" dataType="date" format="shortDate" width="80"></dxi-column>
                    <dxi-column dataField="deleted" dataType="date" format="shortDate" width="80"></dxi-column>
                    <dxi-column></dxi-column>

                    <dxo-summary>
                        <dxi-total-item column="quantity" summaryType="sum" displayFormat="{0}"> </dxi-total-item>
                    </dxo-summary>

                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="order-line-detail-parts-grid"></dxo-state-storing>
                    <!-- <dxo-selection [mode]="'multiple'"></dxo-selection> -->

                    <div *dxTemplate="let data of 'toolbarButtons'"></div>

                    <div *dxTemplate="let data of 'toolbarTextBefore'">
                        <h4>Order Line Parts</h4>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="orderLineDetailPartsGrid" class="me-3">
                            <strong>{{ orderLineDetailPartsGrid.instance.totalCount() + ' items' }}</strong>
                        </span>
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="col-sm-6 d-flex flex-column p-3">
            <div class="grid-fill mb-3">
                <dx-data-grid
                    #purchaseOrderLineReceivingsGrid
                    keyExpr="id"
                    [dataSource]="purchaseOrderLineReceivings"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                >
                    <dxi-column dataField="id" width="65"></dxi-column>
                    <dxi-column dataField="partId" width="65"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Part #" width="100"></dxi-column>
                    <dxi-column dataField="description" width="200"></dxi-column>
                    <dxi-column dataField="quantity" width="70"></dxi-column>
                    <dxi-column dataField="created" dataType="date" format="shortDate" width="80"></dxi-column>
                    <dxi-column dataField="pONumber" caption="PO #" width="80"></dxi-column>
                    <dxi-column></dxi-column>

                    <dxo-summary>
                        <dxi-total-item column="quantity" summaryType="sum" displayFormat="{0}"> </dxi-total-item>
                    </dxo-summary>

                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchase-order-line-receivings-grid"></dxo-state-storing>
                    <dxo-selection [mode]="'single'"></dxo-selection>

                    <div *dxTemplate="let data of 'toolbarButtons'"></div>
                    <div *dxTemplate="let data of 'toolbarTextBefore'">
                        <h4>Purchase Order Receivings</h4>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="purchaseOrderLineReceivingsGrid" class="me-3">
                            <strong>{{ purchaseOrderLineReceivingsGrid.instance.totalCount() + ' items' }}</strong>
                        </span>
                    </div>
                </dx-data-grid>
            </div>
            <div class="grid-fill">
                <dx-data-grid
                    #partPurchasesGrid
                    keyExpr="id"
                    [dataSource]="inventoryAdjustments"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                >
                    <dxi-column dataField="id" width="65"></dxi-column>
                    <dxi-column dataField="partId" width="65"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Part #" width="100"></dxi-column>
                    <dxi-column dataField="description" width="200"></dxi-column>
                    <dxi-column dataField="date" dataType="date" format="shortDate" width="80"></dxi-column>
                    <dxi-column dataField="quantity" width="70"></dxi-column>
                    <dxi-column dataField="price" [format]="{ type: 'currency', precision: 2 }" width="80"></dxi-column>
                    <dxi-column dataField="reason" width="100"></dxi-column>
                    <dxi-column dataField="inStock" width="80"></dxi-column>
                    <dxi-column dataField="allocated" width="80"></dxi-column>
                    <dxi-column dataField="projectedInventory" width="80"></dxi-column>
                    <dxi-column></dxi-column>

                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="part-purchase-grid"></dxo-state-storing>
                    <dxo-selection [mode]="'single'"></dxo-selection>

                    <div *dxTemplate="let data of 'toolbarButtons'"></div>

                    <div *dxTemplate="let data of 'toolbarTextBefore'">
                        <h4>Inventory Adjustments</h4>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="partPurchasesGrid" class="me-3">
                            <strong>{{ partPurchasesGrid.instance.totalCount() + ' items' }}</strong>
                        </span>
                    </div>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
